import { Region } from 'src/app/model/region.model';
import { Student } from '../../../model/student/student.model';
import { StudentTerminationStatus } from './student-termination-status.model';

export class SearchStudent extends Student {
    LEGAL_MOTHERS: LEGALMOTHER[];
    LEGAL_FATHERS: LEGALFATHER[];
    REGIONS: Region[];
}

export interface PARTy {
    ID: number;
}

export interface PERSON {
    ID: number;
    PARTIES_ID: number;
    LAST_NAME: string;
    FIRST_NAME: string;
    MIDDLE_INITIAL: string;
    PARTy: PARTy;
}

export interface COEPEOPLETYPE {
    TYPE: string;
}

export interface LEGALMOTHER {
    ID: number;
    FIRST_NAME: string;
    LAST_NAME: string;
    COE_PEOPLE_TYPE: COEPEOPLETYPE;
}

export interface COEPEOPLETYPE2 {
    TYPE: string;
}

export interface LEGALFATHER {
    ID: number;
    FIRST_NAME: string;
    LAST_NAME: string;
    COE_PEOPLE_TYPE: COEPEOPLETYPE2;
}

export interface PARTYROLE {
    ID: number;
    PARTIES_ID: number;
}

export interface PARTy2 {
    ID: number;
    PARTY_ROLES: PARTYROLE[];
}

export interface ORGANIZATION {
    ID: number;
    PARTIES_ID: number;
    NAME: string;
    PARTy: PARTy2;
}

export interface STUDENTTERMINATIONSTATUSTYPES {
    ID: number;
    TYPE: string;
    DESCRIPTION: string;
    SELECTABLE?: number;
}

export interface STUDENTTERMINATIONSTATUS {
    ID: number;
    STUDENTS_ID: number;
    STUDENT_TERMINATION_STATUS_TYPES_ID: number;
    STATUS_DATE: Date;
    CREATED_DATE: Date;
    CREATED_BY: string;
    STUDENT_TERMINATION_STATUS_TYPES: STUDENTTERMINATIONSTATUSTYPES;
}
